import { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import stockWidthImage from '../../../assets/docs/robot-program/Stock Width.jpg';
import stockLengthImage from '../../../assets/docs/robot-program/Stock Length.jpg';
import stockHeightImage from '../../../assets/docs/robot-program/Stock Height.jpg';
import pickHeightImage from '../../../assets/docs/robot-program/Pick Height.jpg';
import op1ToOp2TransferHeightImage from '../../../assets/docs/robot-program/Op1 to Op2 Transfer Height.jpg';

// VersaBuilt names the stock dimensions width/length/partHeight, but they
// describe the raw stock the robot picks, not the finished part.
export const STOCK_DIMENSION_HELP: Record<
	string,
	{ title: string; description: string; image: string }
> = {
	width: {
		title: 'Stock Width',
		description: 'Across both jaws, in the direction the vise clamps.',
		image: stockWidthImage,
	},
	length: {
		title: 'Stock Length',
		description: 'Along the jaws, perpendicular to the clamping direction.',
		image: stockLengthImage,
	},
	partHeight: {
		title: 'Stock Height',
		description: 'Thickness of the stock as it sits on the jaws.',
		image: stockHeightImage,
	},
	pickHeight: {
		title: 'Pick Height',
		description: 'From the bottom of the jaws to the top of the stock.',
		image: pickHeightImage,
	},
	op1to2TransferHeight: {
		title: 'Op1 to Op2 Transfer Height',
		description:
			'From the bottom of the Op 1 jaws to the bottom of the Op 2 jaws, which sit upside down over the part during the transfer.',
		image: op1ToOp2TransferHeightImage,
	},
};

const StockDimensionHelp = ({ parameterKey }: { parameterKey: string }) => {
	const [open, setOpen] = useState(false);
	const help = STOCK_DIMENSION_HELP[parameterKey];
	if (!help) {
		return null;
	}
	return (
		<>
			<Tooltip title={`What is ${help.title}?`}>
				<QuestionCircleOutlined
					className="ml-1 text-slate-400 hover:text-[#1677ff] cursor-pointer"
					onClick={(e) => {
						e.stopPropagation();
						setOpen(true);
					}}
				/>
			</Tooltip>
			<Modal
				title={help.title}
				open={open}
				onCancel={() => setOpen(false)}
				footer={null}
				width={720}
				centered
			>
				<img src={help.image} alt={help.title} className="w-full rounded border mb-3" />
				<div className="text-slate-500">{help.description}</div>
			</Modal>
		</>
	);
};

export default StockDimensionHelp;
